/**
 * @fileoverview Barrel exports for the plot-synopsis-extractor-chunked-v3 agent.
 */

export { definition } from './definition';
export { flow, plotSynopsisExtractorChunkedV3AgentFlow } from './flow';
export { InputSchema, OutputSchema } from './schema';
export type { Input, Output } from './schema';
export { prompt } from './prompt';
